import React from 'react';
import { useTabs } from '../../context';
import styles from '../../Tabs.module.scss';
const TabPane = ({ id, children }) => {
    const { activeTab } = useTabs();
    const isActive = activeTab === id;
    if (!isActive)
        return null;
    return React.createElement("div", { className: styles.tabPane }, children);
};
export default TabPane;
